var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4621_18422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42212 2.84326H9.95186",
    stroke: "#FB2C36",
    strokeWidth: 0.947749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00339 2.84326V9.47751C9.00339 9.95138 8.52951 10.4253 8.05564 10.4253H3.31689C2.84302 10.4253 2.36914 9.95138 2.36914 9.47751V2.84326",
    stroke: "#FB2C36",
    strokeWidth: 0.947749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79126 2.84298V1.89523C3.79126 1.42135 4.26513 0.947479 4.73901 0.947479H6.63451C7.10838 0.947479 7.58226 1.42135 7.58226 1.89523V2.84298",
    stroke: "#FB2C36",
    strokeWidth: 0.947749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7395 5.21234V8.05559",
    stroke: "#FB2C36",
    strokeWidth: 0.947749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63477 5.21234V8.05559",
    stroke: "#FB2C36",
    strokeWidth: 0.947749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4621_18422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.373,
    height: 11.373,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.62bec4be60f0c1a6b43bb97b2198141e.svg";
export { ForwardRef as ReactComponent };